/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

import { tReservationMode } from './schemas';

export const tMaxOrderSetting = t.type({
  day_of_week: t.string,
  enabled: t.boolean,
  id: t.number,
  max_order_limit: t.number,
  reservation_mode: tReservationMode,
  start_time: t.string,
});
export type MaxOrderSetting = t.TypeOf<typeof tMaxOrderSetting>;
